import React from "react";
import { NFT_MARKETPLACE_URL, MARKETPLACE_LOGO } from "../../common/constants";

import needle from "../../resources/images/splash/needle.gif";
import potion from "../../resources/images/splash/potion.gif";

export function Wallet(): React.ReactElement {

  return(
    <div className="temp-wallet-wrapper">
      <div className="temp-message">
        The Plague Pits arrival is imminent...
      </div>
      <div className="temp-wallet-image-wrapper">
        <img
          className="needle-gif"
          id="needle-gif"
          alt="needle-gif"
          src={needle}
          style={{
            height: "10vh",
            zIndex: 100,
          }}
        /> 
        <img
          className="potion-gif"
          id="potion-gif"
          alt="potion-gif"
          src={potion}
          style={{
            height: "10vh",
            zIndex: 100,
          }}
        /> 
        <img
          className="needle-gif"
          id="needle-gif"
          alt="needle-gif"
          src={needle}
          style={{
            height: "10vh",
            zIndex: 100,
          }}
        /> 
      </div>
      <div className="marketplace-link-wrapper">
        Checkout your mints here:
        <a 
          className="marketplace-logo-anchor"
          rel="noopener noreferrer"
          target="_blank"
          href={NFT_MARKETPLACE_URL}
        >
          <img 
            className="marketplace-logo-img"
            src={MARKETPLACE_LOGO} 
            alt="Marketplace Logo"
          />
        </a>
      </div>
    </div>
  )
}
